var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"point-grounp"},_vm._l((5),function(item,index){return _c('span',{key:index,staticClass:"point",class:{ active: index === _vm.PageIndex },on:{"click":function($event){_vm.pointClick(index);
      _vm.childChangeIndex();}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }